import React from 'react';

export const Card = ({ children, className = '', padding = true, hover, onClick }) => {
  return (
    <div
      className={`bg-white rounded-lg border border-gray-200 ${padding ? 'p-5' : ''} ${hover ? 'hover:border-gray-300 hover:shadow-sm transition-all cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '' }) => (
  <div className={`flex items-center justify-between mb-4 ${className}`}>{children}</div>
);

export const CardTitle = ({ children, className = '' }) => (
  <h3 className={`text-base font-semibold text-gray-900 ${className}`}>{children}</h3>
);
